module.exports = __webpack_public_path__ + "static/media/logo.fd360f21.png";